export const ar = {
    app: { name: "FiscoAI", tagline: "مساعد ضريبي إيطالي" },
    nav: {
        chat: "محادثة الذكاء الاصطناعي",
        clients: "العملاء",
        pratiche: "الملفات",
        telematico: "الإرسال الإلكتروني",
        credits: "الرصيد",
        admin: "الإدارة",
        affiliates: "الشركاء",
        pricing: "قائمة الأسعار",
        stats: "الإحصائيات",
        logout: "خروج",
        settings: "الإعدادات",
    },
    auth: {
        loginTitle: "تسجيل الدخول إلى FiscoAI",
        loginSubtitle: "برنامج احترافي لإدارة الرقم الضريبي والامتثال الضريبي.",
        registerTitle: "أنشئ حسابك",
        registerSubtitle: "سجل كشريك وابدأ على الفور.",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        fullName: "الاسم الكامل",
        loginBtn: "دخول",
        registerBtn: "تسجيل",
        noAccount: "ليس لديك حساب؟",
        hasAccount: "لديك حساب بالفعل؟",
        registerLink: "سجل الآن",
        loginLink: "تسجيل الدخول",
        loginError: "بيانات الاعتماد غير صحيحة",
        serverWaking: "الخادم قيد التشغيل، انتظر بضع ثوانٍ وحاول مرة أخرى. بيانات الاعتماد الخاصة بك صحيحة.",
        registerError: "خطأ في التسجيل",
    },
    chat: {
        welcomeTitle: "صباح الخير",
        welcomeSubtitle: "كيف يمكنني مساعدتك اليوم؟",
        placeholder: "اكتب رسالة أو اسحب وثيقة هوية...",
        send: "إرسال",
        newChat: "محادثة جديدة",
        attach: "إرفاق ملف",
        suggested: [
            { title: "فتح رقم ضريبي جديد", body: "أريد فتح رقم ضريبي برمز ATECO 62.01.00 من 01/01/2026 بنظام مبسط." },
            { title: "تعديل AA9/12", body: "أريد تعديل نشاط الرقم الضريبي لعميل." },
            { title: "إغلاق الرقم الضريبي", body: "أحتاج إلى إغلاق الرقم الضريبي لعميل في 31/12/2025." },
            { title: "استخراج بيانات من وثيقة", body: "استخرج البيانات الشخصية من وثيقة الهوية هذه." },
        ],
        emptyConversations: "لا توجد محادثات",
        confirmDelete: "هل تريد حذف هذه المحادثة؟",
        creditsCharged: "الرصيد المستخدم",
    },
    clients: {
        title: "سجل العملاء",
        subtitle: "أدر عملاءك ومعلوماتهم الضريبية.",
        newClient: "عميل جديد",
        search: "ابحث بالاسم، الرمز الضريبي أو الرقم الضريبي...",
        empty: "لا يوجد عملاء مسجلون",
        editClient: "تعديل العميل",
        createClient: "إنشاء عميل",
        save: "حفظ",
        cancel: "إلغاء",
        confirmDelete: "حذف هذا العميل نهائياً؟",
        fields: {
            codice_fiscale: "الرمز الضريبي",
            cognome: "اللقب",
            nome: "الاسم",
            sesso: "الجنس",
            data_nascita: "تاريخ الميلاد",
            comune_nascita: "بلدة الميلاد",
            provincia_nascita: "محافظة الميلاد",
            cittadinanza: "الجنسية",
            email: "البريد الإلكتروني",
            telefono: "الهاتف",
            comune_residenza: "بلدة الإقامة",
            provincia_residenza: "المحافظة",
            cap_residenza: "الرمز البريدي",
            indirizzo_residenza: "العنوان",
            civico_residenza: "رقم المبنى",
            partita_iva: "الرقم الضريبي",
            notes: "ملاحظات",
        },
    },
    pratiche: {
        title: "الملفات",
        subtitle: "جميع الملفات المُعدّة والقيد التنفيذ.",
        newPratica: "ملف جديد",
        empty: "لا توجد ملفات بعد",
        emptyHint: "ابدأ محادثة مع FiscoAI لتوليد ملفك الأول.",
        status: {
            draft: "مسودة",
            review: "قيد المراجعة",
            ready: "جاهز للإرسال",
            submitted: "مُرسَل",
            accepted: "مقبول",
            rejected: "مرفوض",
        },
        validate: "تحقق",
        generate: "توليد ملف ضريبي",
        download: "تنزيل .ccf",
        markSubmitted: "وضع علامة كمُرسَل",
        instructionsTitle: "كيفية الإرسال عبر Desktop Telematico",
        instructions: [
            "افتح Desktop Telematico (وكالة الإيرادات) على جهاز الكمبيوتر.",
            "اذهب إلى وحدة «File Internet» ← «Controlla file».",
            "حمّل ملف .ccf الذي تم تنزيله.",
            "نفّذ «Prepara file» باستخدام شهادة Entratel الخاصة بك.",
            "اختر «Invia» وانتظر إيصال البروتوكول.",
            "عُد إلى هنا واضغط «وضع علامة كمُرسَل» مع إدخال رقم البروتوكول.",
        ],
    },
    calc: {
        button: "حساب تلقائي",
        done: "تم تنفيذ الحسابات وحفظها في الجداول",
        summaryTitle: "ملخص الحسابات",
        disclaimer: "حساب تقريبي (معدلات وخصومات 2025/2026 بصيغة مبسطة). تحقق دائماً من النتائج قبل الإرسال.",
        f24Button: "إنشاء F24",
        f24Created: "تم إنشاء F24 من الإقرار",
    },
    precompilata: {
        title: "الإقرار الضريبي المعبأ مسبقاً",
        subtitle: "استرجع بيانات الإقرار المعبأ مسبقاً من وكالة الضرائب: عبر تفويض الوسيط (القناة الإلكترونية) أو بتحميل الملف الذي نزّله المكلف عبر SPID.",
        viaDelega: "طلب عبر تفويض الوسيط",
        viaSpid: "لدي الإقرار المعبأ (SPID)",
        richiestaStarted: "تم إرسال الطلب إلى القناة الإلكترونية! تابع التقدم في الإرسال الإلكتروني.",
        importing: "جارٍ استخراج البيانات من الإقرار المعبأ...",
        imported: "تم استيراد البيانات إلى الملف",
        received: "تم استلام الإقرار المعبأ من القناة الإلكترونية — متوفر في أرشيف الخادم.",
        uploadBtn: "تحميل ملف الإقرار المعبأ (XML أو PDF)",
        spidTitle: "كيفية استرجاع الإقرار المعبأ عبر SPID",
        spidSteps: [
            "يدخل المكلف إلى www.agenziaentrate.gov.it → «Dichiarazione precompilata» عبر SPID/CIE/CNS.",
            "من قسم «عرض الإقرار» يقوم بتنزيل ملف PDF أو XML.",
            "اطلب الملف وحمّله هنا: سيستخرج الذكاء الاصطناعي البيانات تلقائياً في الجداول.",
        ],
    },
    templates: {
        title: "النماذج المحفوظة",
        empty: "لا توجد نماذج محفوظة",
        emptyHint: "افتح ملفاً واضغط «حفظ كنموذج» لإعادة استخدامه لاحقاً.",
        use: "استخدام النموذج",
        global: "عام",
        duplicate: "نسخ الملف",
        duplicated: "تم نسخ الملف! أنت الآن تعمل على النسخة.",
        saveAs: "حفظ كنموذج",
        saved: "تم حفظ النموذج! تجده في الملفات → النماذج.",
        namePrompt: "اسم النموذج:",
        globalPrompt: "جعل هذا النموذج عاماً (مرئي لجميع الشركاء)؟",
        confirmDelete: "هل تريد حذف هذا النموذج نهائياً؟",
        deleted: "تم حذف النموذج",
        createdFromTemplate: "تم إنشاء ملف من النموذج!",
    },
    telematico: {
        title: "الإرسال الإلكتروني",
        subtitle: "إرسال تلقائي للملفات إلى وكالة الضرائب الإيطالية (قناة Entratel/Fisconline).",
        tabInvii: "الإرسالات",
        tabSettings: "الإعدادات",
        empty: "لا توجد إرسالات بعد",
        emptyHint: "قم بإنشاء ملف واضغط «إرسال إلى وكالة الضرائب» لبدء الإرسال التلقائي.",
        installed: "Desktop Telematico مثبت على الخادم — الوضع الحقيقي متاح",
        notInstalled: "Desktop Telematico غير مثبت على الخادم",
        simulationNote: "سيتم تنفيذ الإرسالات في وضع المحاكاة. للإرسال الحقيقي، قم بتثبيت Desktop Telematico على خادم الإنتاج وضبط المتغير DESKTOP_TELEMATICO_HOME.",
        simBadge: "محاكاة",
        protocol: "رقم البروتوكول",
        ricevutaOfficial: "الإيصال الرسمي من وكالة الضرائب",
        ricevutaAvailableHint: "ملف PDF مولّد من ملف ‎.rel الرسمي، ويحتوي على النتيجة وسبب الرفض إن وجد.",
        downloadRicevuta: "تحميل إيصال PDF",
        downloadRel: "تحميل ملف ‎.rel",
        ricevutaDownloaded: "تم إرسال الإيصال إلى المتصفح",
        esitoLabel: "النتيجة الرسمية",
        esito: {
            ACCOLTA: "مقبولة",
            SCARTATA: "مرفوضة",
            IN_ELABORAZIONE: "قيد المعالجة",
        },
        fetchRicevuta: "استرجاع إيصال وكالة الضرائب",
        ricevutaFetched: "تم استرجاع الإيصال الرسمي",
        confirmInvio: "تأكيد الإرسال إلى وكالة الضرائب",
        confirmInvioPrompt: "هل تؤكد الإرسال النهائي لهذا الملف إلى وكالة الضرائب؟ لا يمكن التراجع عن هذه العملية.",
        invioConfermato: "تم تأكيد الإرسال: جارٍ الإرسال",
        diag: {
            title: "تشخيص أوامر Entratel-Multifile",
            workDir: "مجلد العمل",
            runAs: "مستخدم التنفيذ",
            notConfigured: "غير مُهيأ (الرجوع إلى سكربتات Desktop Telematico)",
            missing: "غير موجود",
            notExecutable: "غير قابل للتنفيذ",
            mock: "MOCK/STUB — غير صالح للوضع الحقيقي",
            writable: "قابل للكتابة",
            notWritable: "غير قابل للكتابة",
        },
        blockedTitle: "الوضع الحقيقي محظور",
        confirmModal: {
            title: "تأكيد الإرسال النهائي",
            warning: "أنت على وشك الإرسال النهائي لهذا الملف إلى وكالة الضرائب. لا يمكن التراجع عن هذه العملية.",
            model: "النموذج",
            pratica: "الملف",
            authFile: "الملف الموثق",
            size: "الحجم",
            missingAuth: "الملف الموثق غير متوفر: لا يمكن متابعة الإرسال.",
            cancel: "إلغاء",
            continueBtn: "متابعة",
            typePrompt: "للتأكيد على الإرسال، اكتب INVIA:",
            confirmBtn: "تأكيد وإرسال",
            starting: "جارٍ بدء الإرسال…",
        },
        retry: "إعادة المحاولة",
        retryStarted: "تمت إعادة محاولة الإرسال",
        sendToAde: "إرسال إلى وكالة الضرائب",
        sendStarted: "بدأ الإرسال! تابع التقدم في قسم الإرسال الإلكتروني.",
        status: {
            queued: "في الانتظار",
            controllo: "فحص",
            autentica: "توثيق",
            invio: "إرسال",
            ricevuta: "إيصال",
            awaiting_confirmation: "بانتظار التأكيد",
            completed: "مكتمل",
            failed: "فشل",
        },
        settingsForm: {
            credentialsSection: "بيانات اعتماد Entratel / Fisconline",
            tipoUtente: "نوع الحساب",
            utente: "رمز المستخدم",
            password: "كلمة المرور",
            passwordHint: "كلمة مرور الدخول إلى الخدمات الإلكترونية (القصيرة، تُستخدم مع PIN عند الإرسال)",
            pin: "الرقم السري PIN",
            pinHint: "الرقم السري للحساب (يُستخدم عند الإرسال)",
            sede: "الرقم التسلسلي للمقر",
            cfIntermediario: "الرمز الضريبي للوسيط",
            envPath: "مسار بيئة الأمان (الشهادة)",
            envPassword: "كلمة مرور بيئة الأمان",
            envPasswordHint: "كلمة مرور حماية بيئة الأمان (الطويلة، المختارة عند إنشاء الشهادات، تُستخدم عند التوثيق/التوقيع)",
            modeSection: "وضع الإرسال",
            modeSim: "محاكاة",
            modeSimDesc: "يحاكي كامل العملية (فحص، توثيق، إرسال، إيصال) دون إرسال أي شيء فعلياً. مثالي للاختبار.",
            modeReal: "حقيقي (Entratel Multifile)",
            modeRealDesc: "يستخدم السكربتات الرسمية لوكالة الضرائب المثبتة على الخادم لإرسال الملفات فعلياً.",
            modeRealDisabled: "غير متاح: Desktop Telematico غير مثبت على الخادم.",
        },
        saved: "تم حفظ الإعدادات",
    },
    credits: {
        title: "الرصيد",
        balance: "رصيد الرصيد",
        topup: "شحن الرصيد",
        history: "سجل المعاملات",
        equivalentEur: "1 رصيد = 1 يورو",
        choosePackage: "اختر باقة",
        proceedToPay: "اذهب إلى الدفع",
        paymentSuccess: "تم تأكيد الدفع!",
        paymentSuccessHint: "تمت إضافة الرصيد إلى حسابك.",
        paymentCancel: "تم إلغاء الدفع",
        paymentCancelHint: "لم يتم إجراء أي خصم.",
        backToCredits: "العودة إلى الرصيد",
        emptyTx: "لا توجد معاملات",
    },
    admin: {
        affiliates: "إدارة الشركاء",
        affiliatesSubtitle: "أنشئ، عدّل وأدر أرصدة شركائك.",
        pricing: "قائمة الأسعار",
        pricingSubtitle: "عدّل الرصيد المطلوب لكل نوع ملف.",
        stats: "الإحصائيات",
        statsSubtitle: "نظرة عامة على المنصة والاستهلاك.",
        newAffiliate: "شريك جديد",
        active: "نشط",
        disabled: "معطّل",
        editPrice: "تعديل السعر",
        savePrice: "حفظ",
        statusActive: "نشط",
        statusComingSoon: "قريباً",
        statusIntegration: "تكامل",
        statusDisabled: "معطّل",
        kpi: {
            affiliates: "الشركاء النشطون",
            clients: "إجمالي العملاء",
            pratiche: "إجمالي الملفات",
            submitted: "الملفات المُرسَلة",
            credits: "الرصيد المتداول",
            revenue: "الإيرادات (€)",
        },
    },
    common: {
        loading: "جاري التحميل...",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل",
        confirm: "تأكيد",
        close: "إغلاق",
        searching: "بحث...",
        you: "أنت",
        ai: "FiscoAI",
        creditsLeft: "الرصيد",
    },
};
